import axiosInstance from "./AxiosInstance";
const token = "e532c7ba3d7dd872df0f67576c161969";


export function getImportantQuestions(patient_id , is_important) {
  return axiosInstance.post(
    '/admin/answerList',
    { patient_id, is_important }
  );
}